module.exports = __webpack_public_path__ + "img/software_symphony.7d629721.jpg";